import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import ParticipantService from "@/views/sidebar/participant/participant.service";
import { 
  Medication, 
  Imei,
  ParticipantStatus,
  ParticipantDetailModel
} from "@/views/sidebar/participant/participant.types";

@Module({ namespaced: true })
class Research extends VuexModule {
  medications: Medication[] = [];
  imeis: Imei[] = [];
  participantStatus: ParticipantStatus[] = [];

  private _initialState!: Record<string, any>;

  constructor(module: any) {
    super(module);
    this._initialState = { ...this };
  }

  @Action({ rawError: true })
  async fetchActiveMedications(clientId: number) {
    const medications = await ParticipantService.GetActiveMedications(clientId);
    this.context.commit("updateField", {
      path: "medications",
      value: medications
    });
  }

  @Action({ rawError: true })
  async fetchActiveImeis(clientId: number) {
    const imeis = await ParticipantService.GetActiveImeis(clientId);
    const imeisWithUnassign = [
      { text: "Unassign", value: null },
      ...imeis
    ];
    this.context.commit("updateField", {
      path: "imeis",
      value: imeisWithUnassign
    });
  }

  @Action({ rawError: true })
  async upsertParticipantDetails(participantDetailModel: ParticipantDetailModel) {
    try {
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: null
      }, { root: true });
      await ParticipantService.UpsertParticipantDetails(participantDetailModel);
    } catch (e: any) {
      const errorMessage = e.response?.data || e.response.data.message || "An unexpected error occurred.";
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: errorMessage
      }, { root: true });
    }
  }

  @Action({ rawError: true })
  async fetchParticipantStatus(clientId: number) {
    const participantStatus = await ParticipantService.GetParticipantStatus(clientId);
    this.context.commit("updateField", {
      path: "participantStatus",
      value: participantStatus
    });
  }

  @Action({ rawError: true })
  resetState() {
    for (const key of Object.keys(this._initialState)) {
      this.context.commit("updateField", {
        path: key,
        value: this._initialState[key]
      });
    }
  }
}

Research.getters = { getField };
Research.mutations = { updateField };

export default Research;